import { z } from 'zod';

export const APIMetaInformation = z
  .object({
    publicDynamicAssetsDomainName: z.string(),
  })
  .describe('APIMetaInformation');

export type APIMetaInformation = z.infer<typeof APIMetaInformation>;
